import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DashedWrapper, DocUploadIcon, UploadWrapper, IconWrapper, UploadText } from './drag-and-drop-v2.styles';

class DragAndDropV2 extends Component {
  dropRef = React.createRef();

  static propTypes = {
    handleDroppedFile: PropTypes.func.isRequired,
    fileDropLimit: PropTypes.number.isRequired,
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.elementType]).isRequired,
    overrideDragging: PropTypes.string
  }

  static defaultProps = {
    overrideDragging: null
  }

  state = {
    dragging: false,
    overFileDropLimit: false
  }

  componentDidMount() {
    this.dragCounter = 0
    const div = this.dropRef.current;
    div.addEventListener('dragenter', this.handleDragIn);
    div.addEventListener('dragleave', this.handleDragOut);
    div.addEventListener('dragover', this.handleDrag);
    div.addEventListener('drop', this.handleDrop);
  }

  componentWillUnmount() {
    const div = this.dropRef.current;
    div.removeEventListener('dragenter', this.handleDragIn);
    div.removeEventListener('dragleave', this.handleDragOut);
    div.removeEventListener('dragover', this.handleDrag);
    div.removeEventListener('drop', this.handleDrop);
  }

  handleDrag = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  handleDragIn = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const { fileDropLimit } = this.props;
    this.dragCounter++;
    if (event.dataTransfer.items && event.dataTransfer.items.length > fileDropLimit) {
      this.setState({overFileDropLimit: true});
    } else if (event.dataTransfer.items && event.dataTransfer.items.length > 0) {
      this.setState({dragging: true});
    };
  };

  componentDidUpdate(prevProps) {
    if (prevProps.overrideDragging !== this.props.overrideDragging && this.props.overrideDragging !== null) {
      this.handleDragOut();
    }
  }

  handleDragOut = (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    this.dragCounter--;
    if (this.dragCounter > 0) return;
    this.setState({dragging: false, overFileDropLimit: false});
  };

  handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const { handleDroppedFile, fileDropLimit } = this.props;
    if (event.dataTransfer.files && event.dataTransfer.files.length > 0 && event.dataTransfer.files.length <= fileDropLimit) {
      handleDroppedFile(event.dataTransfer.files)
      event.dataTransfer.clearData();
      this.dragCounter = 0;
    };
    this.setState({dragging: false});
  };

  render() {
    const { dragging, overFileDropLimit } = this.state;
    const { children } = this.props;
    return (
      <DashedWrapper dragging={dragging} ref={this.dropRef}>
        {dragging && !overFileDropLimit &&
          <UploadWrapper>
            <IconWrapper>
              <DocUploadIcon />
            </IconWrapper>
            <UploadText>Drop your document to upload</UploadText>
          </UploadWrapper>
        }
        { !dragging && children }
      </DashedWrapper>
    );
  }
}

export default DragAndDropV2;
